document.documentElement.classList.remove('no-js');
const header=document.querySelector('.si-brand .site-header');
if(header){
  const menu=header.querySelector('.menu-toggle');
  const navigation=header.querySelector('.main-nav');
  const search=header.querySelector('.header-search');
  const closeMenu=()=>{
    menu.setAttribute('aria-expanded','false');
    header.classList.remove('nav-open');
  };
  menu.addEventListener('click',()=>{
    const open=menu.getAttribute('aria-expanded')!=='true';
    menu.setAttribute('aria-expanded',String(open));
    header.classList.toggle('nav-open',open);
    if(open)search.open=false;
  });
  navigation.querySelectorAll('a').forEach(link=>link.addEventListener('click',closeMenu));
  document.addEventListener('click',event=>{
    if(!header.contains(event.target)){
      closeMenu();
      header.querySelectorAll('details[open]').forEach(details=>details.open=false);
    }
  });
  header.querySelectorAll('details').forEach(details=>details.addEventListener('toggle',()=>{
    if(!details.open)return;
    header.querySelectorAll('details[open]').forEach(other=>{if(other!==details)other.open=false});
    if(details===search){closeMenu();search.querySelector('input[type="search"]').focus()}
  }));
  document.addEventListener('keydown',event=>{
    if(event.key!=='Escape')return;
    header.querySelectorAll('details[open]').forEach(details=>details.open=false);
    if(menu.getAttribute('aria-expanded')==='true'){closeMenu();menu.focus()}
  });
}
